import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useContext, useMemo, useState } from "react";
import FlowControllerContext from "./context/FlowControllerContext";
import { recurseChildrenForFlowSteps } from "./utils";
export var FlowCtxComponent = function FlowCtxComponent(_ref) {
  var Component = _ref.component;
  var ctx = useContext(FlowControllerContext);

  if (!ctx.currentStep) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Component, ctx);
};

var FlowController = function FlowController(_ref2) {
  var defaultStep = _ref2.defaultStep,
      onChange = _ref2.onChange,
      children = _ref2.children;
  var steps = useMemo(function () {
    return recurseChildrenForFlowSteps([], children);
  }, [children]);
  var defaultStepIdx = defaultStep ? steps.findIndex(function (s) {
    return s.id === defaultStep;
  }) : 0;
  steps[defaultStepIdx].touched = true;

  var _useState = useState(defaultStepIdx),
      _useState2 = _slicedToArray(_useState, 2),
      currentStepIdx = _useState2[0],
      _setCurrentStepIdx = _useState2[1];

  var setCurrentStepIdx = function setCurrentStepIdx(idx) {
    _setCurrentStepIdx(idx);

    if (!steps[idx].touched) {
      steps[idx].touched = true;
    }

    if (onChange) {
      onChange(steps[idx]);
    }
  };

  var handleGotoStep = function handleGotoStep(id) {
    if (typeof id === "number") {
      if (id < 0) {
        return setCurrentStepIdx(0);
      }

      if (id >= steps.length) {
        return setCurrentStepIdx(steps.length - 1);
      }

      setCurrentStepIdx(id);
      return;
    }

    var idx = steps.findIndex(function (v) {
      return v.id === id;
    });

    if (idx < 0) {
      return;
    }

    setCurrentStepIdx(idx);
  };

  var handleNextStep = function handleNextStep() {
    handleGotoStep(currentStepIdx + 1);
  };

  var handlePrevStep = function handlePrevStep() {
    handleGotoStep(currentStepIdx - 1);
  };

  return /*#__PURE__*/React.createElement(FlowControllerContext.Provider, {
    value: {
      steps: steps,
      nextStep: handleNextStep,
      prevStep: handlePrevStep,
      gotoStep: handleGotoStep,
      currentStep: steps[currentStepIdx]
    }
  }, children);
};

export default FlowController;